module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/passthrough.js
// module id = 536
// module chunks = 1